import { Component, inject, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MediaService } from '@mavles/shared';

@Component({
    selector: 'app-image-editor',
    templateUrl: './image-editor.component.html',
    styleUrls: ['./image-editor.component.scss'],
    standalone: false
})
export class ImageEditorComponent implements OnInit {

 
  @Input() formcontrol!: AbstractControl<any, any> | null;
  @Input() editable = false;
  @Input() image_id: string |  undefined;
  @Input() only_image = false;
  imageUrl: string | undefined;

  protected mediaService = inject(MediaService);

  ngOnInit(): void {
    this.imageUrl = this.mediaService.getURLByUUID(this.image_id!);
  }
 
  onRemoveFile() {
    this.formcontrol?.setValue(null);
  }

  onChangeContactImage() {
    // Handle contact image change logic here
  }

  onChangeFile($event: Event) {
    const input = $event.target as HTMLInputElement;
    const reader = new FileReader();
    if (input.files && input.files.length > 0) {
      reader.readAsDataURL(input.files[0]);
      reader.onload = () => {
        this.formcontrol?.setValue(reader.result);
        this.imageUrl = reader.result as string;
      };
    }
  }
}


